import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef } from 'react';

import { Icon, IconArrowLeftL, IconDelete } from '@flixbus/honeycomb-icons-react';
import {
	Button,
	DataTable,
	DataTableHead,
	DataTableRow,
	Popup,
	PopupSection,
	Heading,
} from '@flixbus/honeycomb-react';

import Loader from 'common/Loader';
import { addMembersStore } from 'pages/Profile/components/AddMembersModal/AddMembersStore';
import { groupsStore } from 'pages/Profile/GroupsStore';

import { singleGroupStore } from './SingleGroupStore';

import styles from './styles.module.css';

const SingleGroupTab = observer(() => {
	const targetRef = useRef(null);

	useEffect(() => {
		singleGroupStore.getCrewMembers(groupsStore.selectedGroup.id);
	}, []);

	const { members, isLoading, isInDelete } = singleGroupStore;
	const { selectedGroup } = groupsStore;

	const isEmpty = members.length === 0;

	if (isLoading) return <Loader />;

	return (
		<div>
			<div className={styles.back}>
				<Button extraClasses={styles.noBorder} onClick={() => singleGroupStore.reset()}>
					<Icon InlineIcon={IconArrowLeftL} size={3} />
					Back to setting
				</Button>
			</div>

			<h1>Group: {selectedGroup?.name}</h1>
			<h2>{selectedGroup?.description}</h2>
			<div className={styles.btnRight}>
				<Button
					appearance="primary"
					onClick={() => addMembersStore.triggerAddMembers(selectedGroup.id)}
				>
					Add members
				</Button>
			</div>
			<DataTable
				headers={
					<DataTableHead>
						<th style={{ width: '20%' }} scope="col">
							Crew member name
						</th>
						<th scope="col">Employee Number</th>
						<th scope="col">Home location</th>
						<th scope="col">Phone</th>
						<th scope="col" />
					</DataTableHead>
				}
			>
				{isEmpty && (
					<DataTableRow key="empty">
						<td colSpan={5} style={{ textAlign: 'center' }}>
							No members yet
						</td>
					</DataTableRow>
				)}
				{members.map(({ id, fullName, driverCard, currentHomeBase, phone }) => (
					<DataTableRow key={id}>
						<td>{fullName}</td>
						<td>{driverCard}</td>
						<td>{currentHomeBase?.city?.name}</td>
						<td>{phone}</td>
						<td>
							<Button
								onClick={() => singleGroupStore.triggerDeleteMode(id)}
								display="square"
								aria-label="Delete group"
							>
								<Icon InlineIcon={IconDelete} aria-hidden="true" />
							</Button>
						</td>
					</DataTableRow>
				))}
			</DataTable>
			<Popup
				id="group-deletion"
				aria-labelledby="group-creation"
				aria-describedby="group-creation"
				active={isInDelete}
				onOverlayClick={singleGroupStore.resetDeleteMode}
				targetRef={targetRef}
			>
				<PopupSection type="title">
					<Heading id="group-create-header" size={1} sectionHeader>
						Are you sure you want to remove member from this group?
					</Heading>
				</PopupSection>

				<PopupSection type="content" id="creation">
					<div style={{ marginBottom: '12px' }}>
						Member will be deleted. If you will change your mind, you can re-add member to group
						later.
					</div>
				</PopupSection>

				<PopupSection type="actions">
					<Button onClick={singleGroupStore.resetDeleteMode}>Cancel</Button>
					<Button
						appearance="danger"
						onClick={singleGroupStore.deleteMemberFromGroup}
						loading={singleGroupStore.isDeleteLoad}
					>
						Delete
					</Button>
				</PopupSection>
			</Popup>
		</div>
	);
});

export default SingleGroupTab;
